<template>
  <div
    @click="() => $emit('click')"
    :class="['favorite-item d-flex align-items-center justify-content-center', { 'favorite-item-red-cursor': !localStatus }]"
  >
    <transition name="heart-animation-favorite" mode="out-in"> 
      <svg
        v-if="localStatus"
        xmlns="http://www.w3.org/2000/svg"
        :width="localWidth"
        :height="localHeight"
        class="bi bi-heart"
        viewBox="0 0 16 16"
        style="margin: 0 auto;"
         
      >
      
        <path
          d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748z"
          fill="#c12927"
        />
      </svg>
    </transition>
    <transition name="heart-animation-unfavorite" mode="out-in">
      <img
        v-if="!localStatus"
        key="heart-out"
        src="@/assets/images/favorite-heart.png"
        alt="Favorite Heart"
      />
    </transition>
  </div>
</template>

<script>
export default {
  props: ['status', 'width', 'height'],
  data() {
    return {
      localStatus: 0,
      localWidth: 16,
      localHeight: 16
    };
  },
  methods: {
   getCursorStyle() {
      const cursor = this.localStatus
        ? "url('../../assets/images/favorite-heart-red.png'), auto"
        : "url('../../assets/images/favorite-heart.png'), auto";

      return {
        cursor,
        width: '32px',
        height: '32px',
        background: '#fff',
        borderRadius: '50%',
        zIndex: 1,
        opacity: 1,
        border: 'solid 1px #e5e5e5'
      };
    }
  },
  mounted() {
    // Logging the favorite value
    console.log('Favorites Value:', this.value);
    this.localStatus = this.status ?? 0;
  },
  watch: {
    status(newValue) {
      console.log("newValue", newValue);
      this.localStatus = newValue;
    }
  }
};
</script>

<style>
.favorite-item {
  width: 32px;
  height: 32px;
  background: #fff;
  border-radius: 50%;
  z-index: 1;
  opacity: 1;
  border: solid 1px #e5e5e5;
  /* cursor: url('../../assets/images/favorite-heart.png'), auto; */
  cursor: pointer;
}

.favorite-item-red-cursor {
  /* cursor: url('../../assets/images/favorite-heart-red.png'), auto; */
  cursor: pointer;
}

/* We added some cool transitions here upon adding to favorites - Eubs */
.heart-animation-favorite-enter-active {
  transition: width 0.5s, height 0.5s;
}

.heart-animation-favorite-enter {
  width: 32px;
  height: 32px;
}

.heart-animation-unfavorite-enter-active {
  transition: opacity 0.8s;
}

.heart-animation-unfavorite-enter,
.heart-animation-unfavorite-leave-to {
  opacity: 0;
}
</style>
